// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import downloadBlobFile from "@store/Framework/Common/Utilities/downloadBlobFile";
import { GetInvoicePdfApiParameter } from "@store/Framework/Services/InvoiceService";
import downloadInvoice from "@store/Framework/Store/Store/Pages/InvoiceDetails/Handlers/DownloadInvoice";
import {
    useInvoicesLoading,
    useIsLoadingInvoice,
} from "@store/Framework/Store/Store/Pages/InvoiceDetails/InvoiceDetailsHooks";
import { useContext } from "react";
import { useDispatch } from "react-redux";

const useDownloadInvoice = () => {
    const dispatch = useDispatch();
    const invoicesLoading = useInvoicesLoading();
    const isLoadingInvoice = useIsLoadingInvoice();
    const toasterContext = useContext(ToasterContext);

    return {
        downloadInvoice: (apiParameters: GetInvoicePdfApiParameter) => {
            dispatch(
                downloadInvoice({
                    ...apiParameters,
                    onSuccess: downloadBlobFile,
                    onError: () => {
                        toasterContext.addToast({
                            body: translate("Cansel_DownloadInvoice_Error"),
                            messageType: "danger",
                        });
                    },
                }),
            );
        },
        invoicesLoading,
        isLoadingInvoice,
    };
};

export default useDownloadInvoice;
